// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"434":"f46a296c","930":"36147041"}[chunkId] + ".chunk.css";
};